import { VODCSSModules } from 'shared/utils/wix-connect';
import MenuIcon from 'static/images/menu.svg';

import styles from './menu-button.styl';

@VODCSSModules(styles)
export default class MenuButton extends React.Component {
  static propTypes = {
    onClick: React.PropTypes.func,
    className: React.PropTypes.func,
  };

  render() {
    const { onClick, className } = this.props;

    return (
      <button onClick={onClick}
              data-hook="menuButton"
              className={className}
              styleName="button icon">
        <MenuIcon />
      </button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/views/desktop/compact/components/menu-button/menu-button.js